import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { useTranslation } from 'react-i18next';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { getAge } from '../../utils/child-bio.ts';

/**
 * Child bio info section
 */
export const ChildBioInfo = t0 => {
  const $ = _c(61);
  const {
    details,
    countryKey,
    note
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== details.ageInYearsAndMonths) {
    t2 = getAge(details.ageInYearsAndMonths);
    $[1] = details.ageInYearsAndMonths;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const age = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("bio:age");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="label-xl label-potent ChildBioDetails__label">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== age || $[8] !== t4) {
    t5 = <p>{t4}{age}</p>;
    $[7] = age;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("bio:birthday");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="label-xl label-potent ChildBioDetails__label">{t6}</span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== details.birthDate || $[15] !== t) {
    t8 = new Date(details.birthDate || "").toLocaleDateString(t("bio:localeFormat"), {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    $[14] = details.birthDate;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== details.isBirthDateEstimated || $[18] !== t) {
    t9 = details.isBirthDateEstimated && t("bio:estimatedBirthday");
    $[17] = details.isBirthDateEstimated;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <p>{t7}{t8}{t9}</p>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("bio:gender");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = <span className="label-xl label-potent ChildBioDetails__label">{t11}</span>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== details.gender || $[29] !== t) {
    t13 = t("bio:genders", {
      context: details.gender.toString()
    });
    $[28] = details.gender;
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <p>{t12}{t13}</p>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t("bio:location");
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15) {
    t16 = <span className="label-xl label-potent ChildBioDetails__label">{t15}</span>;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const t17 = countryKey as unknown as TemplateStringsArray;
  let t18;
  if ($[38] !== t || $[39] !== t17) {
    t18 = t(t17);
    $[38] = t;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t16 || $[42] !== t18) {
    t19 = <p>{t16}{t18}</p>;
    $[41] = t16;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t) {
    t20 = t("bio:localId");
    $[44] = t;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t20) {
    t21 = <span className="label-xl label-potent ChildBioDetails__label">{t20}</span>;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== details.localId || $[49] !== t21) {
    t22 = <p>{t21}{details.localId}</p>;
    $[48] = details.localId;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== note || $[52] !== t) {
    t23 = note && <p><span className="label-xl label-potent ChildBioDetails__label">{t("bio:note", {
          interpolation: {
            escapeValue: false
          }
        })}</span>{note}</p>;
    $[51] = note;
    $[52] = t;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t10 || $[55] !== t14 || $[56] !== t19 || $[57] !== t22 || $[58] !== t23 || $[59] !== t5) {
    t24 = <div>{t5}{t10}{t14}{t19}{t22}{t23}</div>;
    $[54] = t10;
    $[55] = t14;
    $[56] = t19;
    $[57] = t22;
    $[58] = t23;
    $[59] = t5;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  return t24;
};